import React from "react";
import { ArrowUpRight, Droplets } from "lucide-react";
import { motion } from "framer-motion";
import wp1 from '../assets/terrace1.jpg';
import wp2 from "../assets/bathroom.webp";
import wp3 from "../assets/basement.jpg";
import wp4 from "../assets/roofcoating1.jpg";
import wp5 from "../assets/kitchen13.jpg";
import wp6 from "../assets/foundation.jpg";

const waterproofingProjects = [
  {
    id: 1,
    title: "Terrace Waterproofing",
    location: "South Delhi",
    img: wp1,
  },
  {
    id: 2,
    title: "Basement Waterproofing",
    location: "Gurgaon",
    img: wp3,
  },
  {
    id: 3,
    title: "Bathroom Waterproofing",
    location: "Noida",
    img:wp2,
  },
  {
    id: 4,
    title: "Roof Coating",
    location: "Jaipur",
    img: wp4,
  },
  {
    id: 5,
    title: "Kitchen Waterproofing",
    location: "Mumbai",
    img: wp5,
  },
  {
    id: 6,
    title: "Foundation Waterproofing",
    location: "Bangalore",
    img:wp6,
  },
];

const WaterproofingProjectsSection = () => {
  
  // JSON-LD for Projects List
  const projectsSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": waterproofingProjects.map((project, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "CreativeWork",
        "name": project.title,
        "locationCreated": project.location,
        "image": project.img
      }
    }))
  };

  return (
    <section className="py-28 bg-white border-t border-zinc-200">
      
      {/* Schema Script */}
      <script type="application/ld+json">
        {JSON.stringify(projectsSchema)}
      </script>

      <div className="max-w-7xl mx-auto px-6 mb-16">
        <div className="flex items-center gap-3 mb-4">
          <Droplets className="text-amber-600" size={20} />
          <span className="uppercase tracking-[0.2em] text-xs font-bold text-amber-600">
            Luxuriya Waterproofing
          </span>
        </div>

        <h2 className="text-4xl md:text-5xl font-serif text-zinc-900">
          Waterproofing Projects
        </h2>

        <p className="text-zinc-500 mt-4 max-w-2xl text-lg font-light">
          A showcase of our specialized waterproofing works, ensuring long-term
          protection and structural safety across premium properties.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-6">
        <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-16 gap-x-10">
          {waterproofingProjects.map((project, index) => (
            <motion.div 
              key={project.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="group cursor-pointer"
            >
              <div className="relative h-[380px] overflow-hidden mb-6 bg-zinc-50 shadow-sm border border-zinc-100">
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-500 z-10"></div>
                <img 
                  src={project.img} 
                  alt={`${project.title} Project in ${project.location}`} // SEO Alt Text
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              
              <div className="flex justify-between items-start border-b border-zinc-200 pb-5 group-hover:border-amber-600 transition-colors duration-500">
                <div>
                  <h4 className="font-serif text-xl text-zinc-900 mb-1 group-hover:text-amber-800 transition-colors">
                    {project.title}
                  </h4>
                  <p className="text-[11px] text-zinc-500 uppercase tracking-widest font-medium">
                    {project.location}
                  </p>
                </div>
                <div className="w-10 h-10 rounded-full border border-zinc-200 flex items-center justify-center text-zinc-400 group-hover:bg-amber-800 group-hover:text-white group-hover:border-amber-800 transition-all duration-500">
                  <ArrowUpRight size={18} />
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default WaterproofingProjectsSection;